<template>
  <div id="app">
    <!-- 路由页面渲染在这里 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>